import ListProjectsWip from "@components/modules/projects/list-wip";
import { NavigationFinance } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Work in progress`} navigation={<NavigationFinance />}>
    <DemoModule module={Modules.ProjectsWip}>
      <ListProjectsWip />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/work-in-progress")({
  component: Page,
});
